export enum ESumSubAction {
  None,
  NonDocVeriZa,
  PasswordReset,
  DocumentVerify,
  PassportVerify,
  ForgotLogin,
  MobileNumberChange,
  DepositAction,
  WithdrawAction,
  TransferAction,
  SecurityPinChangeAction,
}

export interface ISumSubGenerateToken {
  action: ESumSubAction;
}

export interface ISumSubGenerateTokenPasswordChange
  extends ISumSubGenerateToken {
  mobileNumber: string;
}
